import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import moment from "moment";
import CopyUrlButton from "../../../../../../../components/btns/CopyLinkBtn";
import { usePOPageContext } from "./POPageContext";

// The PO's header fields, in reading order. `wide` fields (long text) take a
// full row.
const PO_DETAIL_FIELDS = [
  { label: "PO Number", field: "poNumber" },
  { label: "PO Rev", field: "rev" },
  { label: "MRQ", field: "mrqNumber" },
  { label: "Date", field: "poDate" },
  { label: "Plant", field: "plant" },
  { label: "Made By", field: "drawnBy" },
  { label: "Title", field: "title", wide: true },
  { label: "Vendor", field: "vendorName" },
  { label: "Vendor Email", field: "vendorEmail" },
];

// Values arrive as strings, numbers, ISO dates or (for plant) an object.
const displayValue = (field, value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "object") return value.name ?? "-";
  if (field === "poDate" && moment(value, moment.ISO_8601, true).isValid()) {
    return moment(value).format("YYYY-MM-DD");
  }
  return String(value);
};

export default function PoDetails({ po, addCopyBtn = true }) {
  const { plantId } = usePOPageContext();

  const poDetails = {
    ...po,
    mrqNumber: po?.mrq?.mrqNumber,
    vendorName: po?.poMaterials?.[0]?.vendor?.name,
    vendorEmail: po?.poMaterials?.[0]?.vendor?.email,
  };

  const link = `/plant/${plantId}/po/${po?.id}`;

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1.5 }}
      >
        <Box>
          <Typography variant="h5">PO Details</Typography>
          {po?.id && (
            <Typography variant="body2" color="text.disabled">
              ID {po.id}
            </Typography>
          )}
        </Box>
        {po?.id && addCopyBtn && (
          <CopyUrlButton label="Copy PO Link" subLink={link} />
        )}
      </Stack>

      <Grid container spacing={1.5}>
        {PO_DETAIL_FIELDS.map(({ label, field, wide }) => (
          <Grid key={field} item xs={wide ? 12 : 6}>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
            <Typography sx={{ fontWeight: 600, wordBreak: "break-word" }}>
              {displayValue(field, poDetails[field])}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
